import useStyles from 'hooks/useStyles';
import PhoneInput1 from 'react-phone-number-input/input';

const PhoneInput = ({ onChange, disabled, width, value }) => {
  const { algorithm } = useStyles();

  return (
    <PhoneInput1
      autoComplete="nope"
      value={value}
      onChange={onChange}
      country="AR"
      style={{ width: width ? width : 200 }}
      maxLength={12}
      disabled={disabled}
      className={algorithm === 'dark' ? 'ant-input-dark' : 'ant-input-light'}
    />
  );
};

export default PhoneInput;
